export const CardStatusEnum = [
  { text: 'CREATED', value: 'CARD_CREATED' },
  { text: 'CANCELLED', value: 'CARD_CANCELLED' },
  { text: 'DEACTIVATED', value: 'CARD_DEACTIVATED' },
  { text: 'ACTIVE', value: 'CARD_ACTIVE' },
  { text: 'BLOCKED', value: 'CARD_BLOCKED' }
]
